export  function usePagination(pp,total) {
    let num=total/pp
    num=Math.ceil(num)
    return new Array(num).fill('').map((item,index)=>index)
}
